import { requestTokenRefresh } from 'viewerEmbedMessenger';

let embedAuthToken: string | undefined;

export function setEmbedAuthToken(token: string) {
  embedAuthToken = token;
}

let singletonTokenRefreshPromise: Promise<string> | undefined;

export async function acquireEmbedAccessToken() {
  if (embedAuthToken) {
    const expirationDate = getJWTTokenExpirationDate(embedAuthToken);

    if (expirationDate) {
      // view token as old when it's 2 minutes from getting expired
      const shouldRequestNewToken =
        expirationDate.getTime() <= new Date().getTime() + 60 * 2 * 1000;

      if (shouldRequestNewToken) {
        const refreshPromise = (() => {
          // to reuse the refresh promise between all requests coming for auth token in quick succession
          if (singletonTokenRefreshPromise === undefined) {
            singletonTokenRefreshPromise = requestTokenRefresh().finally(() => {
              singletonTokenRefreshPromise = undefined;
            });
          }
          return singletonTokenRefreshPromise;
        })();

        return refreshPromise
          .then((refreshedToken) => Promise.resolve(refreshedToken))
          .catch(() => Promise.resolve(embedAuthToken as string));
      }

      return Promise.resolve(embedAuthToken);
    }

    throw new Error('embedAuthToken: could not extract expiration date');
  }

  throw new Error('embedAuthToken is undefined');
}

function getJWTTokenExpirationDate(token: string) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return null; // no expiration set

    const expDate = new Date(payload.exp * 1000); // convert seconds → milliseconds
    return expDate;
  } catch (err) {
    window.console.error(
      'getJWTTokenExpirationDate: Cannot decode token:',
      err,
    );
    return null;
  }
}
